import { render, staticRenderFns } from "./surveyList.vue?vue&type=template&id=70ca4ac8&scoped=true"
import script from "./surveyList.ts?vue&type=script&lang=ts&external"
export * from "./surveyList.ts?vue&type=script&lang=ts&external"
import style0 from "./surveyList.scss?vue&type=style&index=0&id=70ca4ac8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ca4ac8",
  null
  
)

export default component.exports